class Header {
	constructor() {
		this.header = document.querySelector( '.header' );
		this.trigger = document.querySelector( '.header__hamburger' );
		this.overlay = document.querySelector( '.header__nav' );
		this.desktopViewport = window.matchMedia( 'screen and (max-width: 1199px)' );
		this.mobileViewport = window.matchMedia( 'screen and (max-width: 767px)' );
		this.body = document.querySelector( 'body' );
		this.searchButton = document.querySelector( '.header__search-btn' );
		this.searchWrapper = document.querySelector( '.header__search' );
	}

	init() {
		if ( ! this.header ) {
			return;
		}

		this.trigger.addEventListener( 'click', ( e ) => this.setNavState( e ) );

		if ( this.searchButton ) {
			this.searchButton.addEventListener( 'click', () => this.searchToggle() );
		}
	}

	setNavState( e ) {
		e.preventDefault();
		if ( this.header.classList.contains( 'header--open' ) ) {
			this.hideWrapper();
		} else {
			this.showWrapper();
		}
	}

	hideWrapper() {
		this.trigger.classList.remove( 'header__hamburger--open' );
		this.header.classList.remove( 'header--open' );
	}

	showWrapper() {
		this.hideSearch();
		this.trigger.classList.add( 'header__hamburger--open' );
		this.header.classList.add( 'header--open' );
	}

	searchToggle() {
		if ( this.header.classList.contains( 'header--search-open' ) ) {
			this.hideSearch();
		} else {
			if ( this.header.classList.contains( 'header--open' ) ) {
				this.hideWrapper();
			}
			this.openSearch();
		}
	}

	hideSearch() {
		this.header.classList.remove( 'header--search-open' );
		if ( this.searchButton ) {
			this.searchButton.classList.remove( 'header__search-btn--active' );
		}
		this.searchWrapper.classList.remove( 'header__search--open' );
	}

	openSearch() {
		this.searchButton.classList.add( 'header__search-btn--active' );
		this.header.classList.add( 'header--search-open' );
		this.searchWrapper.classList.add( 'header__search--open' );
	}
}

export default new Header();
